import { Component } from '@angular/core';
import {  ActionSheetController, ModalController, NavController, NavParams } from 'ionic-angular';
import { Ortak } from '../../providers/ortak';
import { CarieklePage } from '../CariIslemleri/cariekle/cariekle';
import { CariTahsilatPage } from '../CariIslemleri/cari-tahsilat/cari-tahsilat';
import { CariborcdekontPage } from '../CariIslemleri/cariborcdekont/cariborcdekont';
import { CariHareketleriPage } from '../CariIslemleri/cari-hareketleri/cari-hareketleri';
import { CarialacakdekontPage } from '../CariIslemleri/carialacakdekont/carialacakdekont';
import { CariOdemePage } from '../cari-odeme/cari-odeme';
import { StokhareketleriPage } from '../StokIslemleri/stokhareketleri/stokhareketleri';
import { DepoCikisIslemiPage } from '../depo-cikis-islemi/depo-cikis-islemi';
import { CariIslemPage } from '../CariIslemleri/cari-islem/cari-islem';
import { CariEkstreRaporuPage } from '../cari-ekstre-raporu/cari-ekstre-raporu';
import { BllOrtak } from '../../providers/bll/bll-ortak';

/**
 * Generated class for the ToptancilarListesiPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
 
@Component({
  selector: 'page-toptancilar-listesi',
  templateUrl: 'toptancilar-listesi.html',
})
export class ToptancilarListesiPage {
 aranan = "";
  skip: number = 0;
  take: number = 50;
  cariListesi = [];
  telno="";
  numaralar:any={};


  constructor(public navCtrl: NavController,public bllOrtak:BllOrtak,
    public ortak:Ortak,
    // public call:CallNumber,
    public modalCtrl:ModalController,
    public actionSheetCtrl:ActionSheetController,
     public navParams: NavParams) {
  }

 

  ionViewDidLoad() {
    this.cariAra(null);
  }
  cariAra(e) {
    console.log("CariAra metodu çağrıldı");
    var formData = new FormData();
    formData.append("aranan", this.aranan);
    console.log("Aranan değer:", this.aranan);
    console.log("Servis URL:", this.ortak.ServisUrl);
    
    this.bllOrtak.islem(formData, "CariListesi","", false).then(a => {
      var sonuc = <any>a;
      console.log("Cari listesi sonucu:", sonuc);
      console.log("Sonuc.Sonuc:", sonuc.Sonuc);
      console.log("Sonuc.SonucObject:", sonuc.SonucObject);
      
      if (sonuc && sonuc.SonucObject) {
        this.cariListesi = sonuc.SonucObject;
        console.log("Cari listesi yüklendi, kayıt sayısı:", this.cariListesi.length);
        console.log("İlk cari kaydı:", this.cariListesi[0]);
      } else {
        this.cariListesi = [];
        console.log("Cari listesi boş veya hatalı veri");
        console.log("Sonuc objesi:", JSON.stringify(sonuc));
      }
    }).catch(error => {
      console.error("Cari listesi yüklenirken hata:", error);
      this.cariListesi = [];
      this.ortak.showErrorAlert();
    });
  }
  urunler(e) {

    if (e.keyCode == 13) {
      this.cariAra(e);
    }
  }
  yeni() {
    let modal = this.modalCtrl.create(CarieklePage);
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });

    modal.present();

  }
  CariSil(cari) {
    this.ortak.showConfirmAlert("Uyarı", "Kayıt silinecektir. Devam etmek istiyor musunuz?").then(k => {
      var formData = new FormData();
      
      formData.append("LogicalRef", cari.ID);

      this.bllOrtak.islem(formData, "CariSil", "", true).then(a => {

      }).catch(x => {

        this.ortak.showErrorAlert();
      })
      this.cariAra(null);
    })

}
CariGuncelle(kisi) {
  let modal = this.modalCtrl.create(CarieklePage, { vwCari: kisi });
  modal.onDidDismiss(data => {
    this.ionViewDidLoad();
  });
  modal.present();

}
CariTahsilat(kisi) {
  let modal = this.modalCtrl.create(CariTahsilatPage, { vwCari: kisi });
  modal.onDidDismiss(data => {
    this.ionViewDidLoad();
  });
  modal.present();

}
CariDekont(kisi){
  let modal=this.modalCtrl.create(CariborcdekontPage,{vwCari:kisi});
  modal.onDidDismiss(data=>{
    this.ionViewDidLoad();
  })
  modal.present();
}
carihareketleri(kisi){
  let modal=this.modalCtrl.create(CariHareketleriPage,{vwCari:kisi});
  modal.onDidDismiss(data=>{
    this.ionViewDidLoad();
  })
  modal.present();

}
CariAlacak(kisi){
  let modal=this.modalCtrl.create(CarialacakdekontPage,{vwCari:kisi});
  modal.onDidDismiss(data=>{
    this.ionViewDidLoad();
  })
  modal.present();
}
CariOdeme(kisi){
  let modal = this.modalCtrl.create(CariOdemePage,{ vwCari: kisi });
  modal.onDidDismiss(data => {
    this.ionViewDidLoad();
  });
  modal.present();
}
CariStokHareketleri(kisi)
{
  let modal = this.modalCtrl.create(StokhareketleriPage,{ vwCari: kisi });
  modal.onDidDismiss(data => {
    this.ionViewDidLoad();
  });
  modal.present();
}
CariStokSecimPage(kisi)
{
  let modal = this.modalCtrl.create(this.CariStokSecimPage,{ vwCari: kisi });
  modal.onDidDismiss(data => {
    this.ionViewDidLoad();
  });
  modal.present();
}
DepoCikisi(kisi)
{
  let modal = this.modalCtrl.create(DepoCikisIslemiPage,{ vwCari: kisi });
  modal.onDidDismiss(data => {
    this.ionViewDidLoad();
  });
  modal.present();
}
CariIslemleri(kisi){
  let modal=this.modalCtrl.create(CariIslemPage,{vwCari:kisi});
  modal.onDidDismiss(data=>{
    this.ionViewDidLoad();
   
  });
  modal.present();
  
}

// Cari Ekstre Raporu açma fonksiyonu
CariEkstreRaporu(kisi) {
  console.log("Cari ekstre raporu açılıyor, cari bilgileri:", kisi);
  
  // Cari bilgilerini ekstre raporu sayfasına gönder
  let modal = this.modalCtrl.create(CariEkstreRaporuPage, { 
    vwCari: kisi,
    selectedCariId: kisi.ID,
    cariKodu: kisi.Kodu,
    cariAdi: kisi.Adi,
    cariSoyadi: kisi.Soyadi
  });
  
  modal.onDidDismiss(data => {
    // Modal kapandığında herhangi bir işlem yapılması gerekirse buraya eklenebilir
    console.log("Cari ekstre raporu modal kapatıldı");
  });
  
  modal.present();
}
Islemler(kisi) {
  const actionSheet = this.actionSheetCtrl.create({
    title: 'Cari  İşlemleri',
    buttons: [
     
      {
        text: 'Giriş Yap',
        handler:()=>{
      this.CariStokSecimPage(kisi);
        }
       
      },
      {
        text: 'Çıkış Yap',
        handler:()=>{
      this.DepoCikisi(kisi);
        }
       
      },
      //  {
      //   text: 'Cari Hareketleri',

      //   handler:()=>{
      // this.carihareketleri(kisi);
      //   }
       
      // },
      {
        text: 'Hareketler',

        handler:()=>{
      this.CariStokHareketleri(kisi);
        }
       
      },
      // {
      //   text: 'Alacak Dekontu',

      //   handler:()=>{
      //   this.CariAlacak(kisi);
      //   }
       
      // },
      {
        text: 'Borç Dekontu',

        handler:()=>{
        this.CariDekont(kisi);
        }
       
      },
      {
        text: 'Tahsilat Yap',

        handler:()=>{
        this.CariTahsilat(kisi);
        }
       
      },
      {
        text: 'Ödeme Yap',

        handler:()=>{
          this.CariOdeme(kisi);
        }
       
      },
      {
        text: 'Ekstre Raporu',
        handler: () => {
          this.CariEkstreRaporu(kisi);
        }
      },
      {
        text: 'Düzenle',
        handler: () => {
         this.CariGuncelle(kisi);
        }
      },{
        text: 'İptal ',
        role: 'cancel',
        handler: () => {
          console.log('Cancel clicked');
        }
      }
    ]
  });
  actionSheet.present();
}
ara(kisi) {
  //    this.numaralar=kisi;
  //   var formData = new FormData();
  // formData.append("gidenkayit",JSON.stringify(this.numaralar));
  //   this.bllOrtak.islem(formData, "caritelnogetir", "", false).then(a => {
  //   var sonuc = <any>a;
  //     this.telno = sonuc.SonucObject;
  //       if (this.telno != null && this.telno!= '') {
  //     this.call.callNumber(this.telno, true)
  //       .then(res => console.log('Launched dialer!', res))
  //       .catch(err => console.log('Error launching dialer', err));
  //   }
  //   else {
  //     this.ortak.showBasicAlert("UYARI", "Telefon numarası boş olamaz.");
  //   }

  // })
  
}
// smsgonder(kisi)
// {
//   let modal = this.modalCtrl.create(CarismsgonderPage, { vWKayit: kisi } );
//   modal.onDidDismiss(data => {
//     this.ionViewDidLoad();
//   });
//   modal.present();
// }

}



// WEBPACK FOOTER //
// ./src/pages/toptancilar-listesi/toptancilar-listesi.ts